var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      attrs: {
        "invalid-feedback": _vm.error,
        label: _vm.label,
        "label-for": _vm.config.name
      }
    },
    [
      _vm.config.description
        ? _c("small", { staticClass: "form-text mb-2" }, [
            _vm._v(_vm._s(_vm._.get(_vm.config, "description")))
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.disabled
        ? [
            _c("custom-select-component", {
              attrs: {
                disabled: _vm.disabled,
                value: _vm._.get(_vm.currentValue, "id", null),
                placeholder: _vm.required
                  ? "Please select an option"
                  : "-- None --",
                options: _vm.options
              },
              on: { input: _vm.onInput, change: _vm.onChange }
            })
          ]
        : _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", disabled: "" },
            domProps: { value: _vm._.get(_vm.currentValue, "name") }
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e998931", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e998931","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/LazyLoadingSelectComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6e998931","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/LazyLoadingSelectComponent.vue
// module chunks = 0